/** @domain financingRound — Funding round modeler economic inputs. */
import { z } from 'zod';
import { createDomainField } from './types';
import { composeFormatters, insertCommas, limitDecimalPlaces } from './formatters';

const define = createDomainField('financingRound');

const currencyFormatter = composeFormatters(
  (v) => v.replace(/[^0-9.]/g, ''),
  limitDecimalPlaces(2),
  insertCommas,
);

const percentFormatter = composeFormatters(
  (v) => v.replace(/[^0-9.]/g, ''),
  limitDecimalPlaces(2),
  insertCommas,
);

export const newMoney = define({
  label: 'New Money ($)',
  placeholder: 'Enter new money',
  schema: z.string(),
  adapterHint: 'text',
  formatter: currencyFormatter,
  displayFormat: 'currency',
});

export const valuationAmount = define({
  label: 'Valuation ($)',
  placeholder: 'Enter valuation',
  schema: z.string(),
  adapterHint: 'text',
  formatter: currencyFormatter,
  displayFormat: 'currency',
});

export const optionPoolPercent = define({
  label: 'Option Pool (%)',
  placeholder: 'Enter option pool percent',
  schema: z.string(),
  adapterHint: 'number',
  formatter: percentFormatter,
  displayFormat: 'percentage',
});

export const valuationBasis = define({
  label: 'Valuation basis',
  schema: z.string(),
  adapterHint: 'radio',
  displayFormat: 'text',
});

export const valuationBasisOptions = [
  { value: 'postMoney', label: 'Post-money' },
  { value: 'preMoney', label: 'Pre-money' },
] as const;
